import { useMemo } from 'react';
import { useEventListener } from './useEventListener';
import { throttleInteraction } from '../utils/ui-helpers';
import { isDevelopmentEnvironment } from '../utils/env-utils';
import { Keys } from '../utils/keys';
import { isClient } from '../../common/utils';
import { InputMethod } from '../contexts/InputMethodContext/InputMethodContext';

const mouseMoveThrottleInterval = 5000;

export const useInputMethodListeners = (
  inputMethod: InputMethod,
  setInputMethod: (inputMethod: InputMethod) => void
) => {
  const keydownListener = (e: KeyboardEvent) => {
    if (
      inputMethod !== 'keyboard' &&
      e.keyCode !== Keys.VK_TAB &&
      e.keyCode !== Keys.VK_SHIFT
    ) {
      if (
        document.activeElement !== document.body &&
        e.keyCode === Keys.VK_ENTER
      ) {
        return;
      }
      setInputMethod('keyboard');
    }

    if (e.keyCode === Keys.VK_TAB) {
      setInputMethod('mouse');
    }

    if (!isDevelopmentEnvironment(window.location.hostname)) {
      e.preventDefault(); // Guarding against Telia STB weirdness, be sure before you remove
    }
  };

  const mousemoveListener = useMemo(
    () =>
      throttleInteraction(() => {
        if (inputMethod !== 'mouse') {
          setInputMethod('mouse');
        }
      }, mouseMoveThrottleInterval),
    [setInputMethod, inputMethod]
  );

  const mouseWheelListener = () => {
    if (inputMethod !== 'mouse') {
      setInputMethod('mouse');
    }
  };

  const target = isClient() ? document : undefined;
  useEventListener('keydown', keydownListener, target);
  useEventListener('mousemove', mousemoveListener, target);
  useEventListener('wheel', mouseWheelListener, target);
};
